(() => {
  if (window.CTFooterV11) return;
  window.CTFooterV11 = true;

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-ct-footer-accordion] > summary');
    if (!summary) return;

    const accordion = summary.closest('[data-ct-footer-accordion]');
    if (!accordion) return;

    event.preventDefault();
    accordion.open = !accordion.open;
  });
})();
